import 'css-chunksrc/client/scenes/workloads/wbs/task/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_1i9ps_1",
  "form": "_form_1i9ps_6",
  "hovered": "_hovered_1i9ps_10",
  "name": "_name_1i9ps_1",
  "icon": "_icon_1i9ps_13",
  "input": "_input_1i9ps_36",
  "edition": "_edition_1i9ps_57",
  "editButton": "_editButton_1i9ps_64",
  "tooltip": "_tooltip_1i9ps_68",
  "constrained": "_constrained_1i9ps_88"
};